import createApiServices from './createApiServices'
import {BACKEND_URL} from "../ConfigUrlApi"

const api = createApiServices({baseUrl: BACKEND_URL})

export const addLead = (payload) => {
    return api.makeRequest({
        url: '/crm/addLead',
        method: 'POST',
        data: payload
    })
}

export const getUserSales = (payload, userName = '') => {
    return api.makeRequest({
        url: `/crm/getUserSale?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getApParamV2 = (payload) => {
    return api.makeRequest({
        url: `/crm/getApParamv2`,
        method: 'POST',
        data: payload
    })
}

export const getTenantParam = (userName, payload) => {
    return api.makeRequest({
        url: `/crm/getTenantParam?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserDataLevel = (payload) => {
    return api.makeRequestFull({
        url: `/v1.0/base/getUserDataLevel`,
        method: 'POST',
        data: payload
    })
}
